var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['i-time-picker', {'back-stage': _vm.backStage}]},[(_vm.label)?_c('InputLabel',{attrs:{"text":_vm.label,"required":_vm.required,"backStage":_vm.backStage}}):_vm._e(),_c('TimePicker',_vm._g(_vm._b({class:[_vm.cls],style:(_vm.style),attrs:{"placeholder":_vm.placeholder}},'TimePicker',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }